module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="stage">\n    <div id="main">\n        <div id="content" class="loading"></div>\n    </div>\n</div>\n<div id="modals"></div>';
}
return __p;
};